/**
 * 객체 리스트
 *
 * @since 2018-04-02
 * @author kdydesign.kim
 *
 * @type {*[]}
 */

const hostObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.host.4.in',
      img: require('~/assets/img/icon/ico_host_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.host.4.out',
      img: require('~/assets/img/icon/ico_host_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.host.4.dmz',
      img: require('~/assets/img/icon/ico_host_g.png')
    }
  ]
}
const networkObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.network.4.in',
      img: require('~/assets/img/icon/ico_network_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.network.4.out',
      img: require('~/assets/img/icon/ico_network_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.network.4.dmz',
      img: require('~/assets/img/icon/ico_network_g.png')
    }
  ]
}
const groupObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.group.4.in',
      img: require('~/assets/img/icon/ico_group_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.group.4.out',
      img: require('~/assets/img/icon/ico_group_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.group.4.dmz',
      img: require('~/assets/img/icon/ico_group_g.png')
    }
  ]
}

const domainObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.domain.in',
      img: require('~/assets/img/icon/ico_domain_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.domain.out',
      img: require('~/assets/img/icon/ico_domain_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.domain.dmz',
      img: require('~/assets/img/icon/ico_domain_g.png')
    }
  ]
}

const hostV6ObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.host.6.in',
      img: require('~/assets/img/icon/ico_host_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.host.6.out',
      img: require('~/assets/img/icon/ico_host_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.host.6.dmz',
      img: require('~/assets/img/icon/ico_host_g.png')
    }
  ]
}

const networkV6ObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.network.6.in',
      img: require('~/assets/img/icon/ico_network_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.network.6.out',
      img: require('~/assets/img/icon/ico_network_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.network.6.dmz',
      img: require('~/assets/img/icon/ico_network_g.png')
    }
  ]
}
const groupV6ObjectList = (i18n) => {
  return [
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 0),
      key: 'address.group.6.in',
      img: require('~/assets/img/icon/ico_group_b.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 1),
      key: 'address.group.6.out',
      img: require('~/assets/img/icon/ico_group_o.png')
    },
    {
      label: i18n.tc('op.webFilterProfile_ipCtrlTab_PopUp_SubTitle2', 2),
      key: 'address.group.6.dmz',
      img: require('~/assets/img/icon/ico_group_g.png')
    }
  ]
}
const addrObjectList = (i18n) => {
  return [
    {
      label: i18n.t('op.objectSettings_label_hostObj'),
      key: 'address.host.4',
      img: require('~/assets/img/icon/ico_host_d.png'),
      children: hostObjectList(i18n)
    },
    {
      label: i18n.t('op.objectSettings_label_networkObj'),
      key: 'address.network.4',
      img: require('~/assets/img/icon/ico_network_d.png'),
      children: networkObjectList(i18n)
    },
    {
      label: i18n.t('op.objectSettings_label_groupObj'),
      key: 'address.group.4',
      img: require('~/assets/img/icon/ico_group_d.png'),
      children: groupObjectList(i18n)
    },
    {
      label: i18n.t('op.objectSettings_label_domainObj'),
      key: 'address.domain',
      img: require('~/assets/img/icon/ico_domain_d.png'),
      children: domainObjectList(i18n)
    },
    {
      label: `IPv6 ${i18n.t('op.objectSettings_label_hostObj')}`,
      key: 'address.host.6',
      img: require('~/assets/img/icon/ico_host_d.png'),
      children: hostV6ObjectList(i18n)
    },
    {
      label: `IPv6 ${i18n.t('op.objectSettings_label_networkObj')}`,
      key: 'address.network.6',
      img: require('~/assets/img/icon/ico_network_d.png'),
      children: networkV6ObjectList(i18n)
    },
    {
      label: `IPv6 ${i18n.t('op.objectSettings_label_groupObj')}`,
      key: 'address.group.6',
      img: require('~/assets/img/icon/ico_group_d.png'),
      children: groupV6ObjectList(i18n)
    }
  ]
}
const objectList = (i18n) => {
  return [
    {
      name: i18n.t('op.objectSettings_label_appObject'),
      key: 'application',
      apiKey: 'app'
    },
    {
      name: i18n.t('op.objectSettings_label_appGroupObject'),
      key: 'applicationGroup',
      apiKey: 'app-group'
    },
    {
      name: i18n.t('op.objectSettings_label_appFilterObject'),
      key: 'applicationFilter',
      apiKey: 'app-filter'
    },
    {
      name: i18n.t('op.objectSettings_label_webCateObject'),
      key: 'webCategory',
      apiKey: 'web-category'
    },
    {
      name: i18n.t('op.objectSettings_label_serviceObj'),
      key: 'service',
      apiKey: 'service'
    },
    {
      name: i18n.t('op.objectSettings_label_serviceGroupObj'),
      key: 'serviceGroup',
      apiKey: 'service-group'
    },
    {
      name: i18n.t('op.objectSettings_label_timeObject'),
      key: 'time',
      apiKey: 'time'
    },
    {
      name: i18n.t('op.objectSettings_label_addrObject'),
      key: 'address',
      children: addrObjectList(i18n)
    }
  ]
}

const ipsObjectList = (i18n) => {
  return [
    // {
    //   name: i18n.t('op.objectSettings_label_serviceObj'),
    //   key: 'service',
    //   icon: 'si-icon-service',
    //   apiKey: 'service'
    // },
    {
      name: i18n.t('op.objectSettings_label_addrObject'),
      key: 'address',
      icon: 'si-icon-ip-address',
      children: [
        {
          label: i18n.t('op.objectSettings_label_hostObj'),
          key: 'address.host.4',
          icon: 'si-icon-ipv4-host',
          noTick: true
        },
        {
          label: i18n.t('op.objectSettings_label_networkObj'),
          key: 'address.network.4',
          icon: 'si-icon-ipv4-network',
          noTick: true
        },
        {
          label: i18n.t('op.objectSettings_label_groupObj'),
          key: 'address.group.4',
          icon: 'si-icon-ipv4-group',
          noTick: true
        },
        {
          label: `IPv6 ${i18n.t('op.objectSettings_label_hostObj')}`,
          key: 'address.host.6',
          icon: 'si-icon-ipv6-host',
          noTick: true
        },
        {
          label: `IPv6 ${i18n.t('op.objectSettings_label_networkObj')}`,
          key: 'address.network.6',
          icon: 'si-icon-ipv6-network',
          noTick: true
        },
        {
          label: `IPv6 ${i18n.t('op.objectSettings_label_groupObj')}`,
          key: 'address.group.6',
          icon: 'si-icon-ipv6-group',
          noTick: true
        }
      ]
    }
  ]
}

export {
  objectList,
  ipsObjectList
}
